import { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from '../utils/pubsub'
import { useNavigate } from 'react-router-dom'
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'

type Props = {
    thisProcessData: ObjectStringKeyAnyValue
    processId: string
}

function StartProcess({
    thisProcessData,
    processId
}: Props) {


    const {
        sendMessageToWebsocket,
        tableData,
        setShowModal,
        t
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const [checklistWarnings, setChecklistWarnings] = useState<String[]>([])

    const buttonEnabled = processId && checklistWarnings.length === 0 && thisProcessData.InProgress === false ? true : false

    useEffect(() => {
        if (tableData && tableData.Checklists && thisProcessData) {
            checkForChecklistWarnings()
        }
    }, [tableData, thisProcessData])

    const startProcess = () => {
        if (buttonEnabled) {
            setShowModal({ 'spinner': t('ProcessPages.ProcessSummary.startingProcess') })
            let payload = JSON.stringify({
                action: "processesClient",
                subAction: "startProcess",
                Id: processId
            })

            const unsubscribeUpdate = subscribe("processStarted", data => {
                if (data && data.Id === processId) {
                    setShowModal(null)
                    if (data.nextChecklistPeriod) {
                        navigate(`/checklists/${data.nextChecklistPeriod}`)
                    } else {
                        navigate(`/process/${processId}`)
                    }
                }
                unsubscribeUpdate()
            })
            sendMessageToWebsocket(payload)

        }
    }

    const checkForChecklistWarnings = () => {
        const warnings: string[] = []
        const checklistIdsForProcess = []

        // for each stage in the process, append all checklists
        for (const stageId of Object.keys(thisProcessData.Stages)) {
            const stage = thisProcessData.Stages[stageId]
            if (stage.Checklists && stage.Checklists.length > 0) {
                for (const checklistId of stage.Checklists) {
                    checklistIdsForProcess.push(checklistId)
                }
            }
        }
        const uniqueChecklistIdsForProcess = Array.from(new Set(checklistIdsForProcess))

        for (const checklistId of uniqueChecklistIdsForProcess) {
            const checklistData = tableData.Checklists[checklistId]
            if (!checklistData) {
                warnings.push(checklistId)
            }
            else if (checklistData && checklistData.isChecklistActive !== true) {
                warnings.push(checklistId)
            }
            else if (checklistData && checklistData.userAccess && checklistData.userAccess.type && (checklistData.userAccess.type === 'externalIndividual' || checklistData.userAccess.type === 'externalOrganisation')) {
                warnings.push(checklistId)
            }

        }
        setChecklistWarnings(warnings)
    }


    return <div className={`borderw-full flex flex-col gap-6 items-center`}>
        <p>{t('ProcessPages.ProcessSummary.startNewInstance', { name: thisProcessData.DisplayName ? thisProcessData.DisplayName : `process Id: #${processId}` })}</p>




        {checklistWarnings && checklistWarnings.length > 0 && <RedAlert>
            <div className={`flex flex-col gap-2`}>
                <p className={``}>{t('ProcessPages.ProcessSummary.checklistWarnings', { checklistIds: checklistWarnings.join(', ') })}</p>
            </div>
        </RedAlert>}


        <Button
            onClick={startProcess}
            text={t('ProcessPages.ProcessSummary.startProcess')}
            fullwidth={false}
            size={`big`}
            variant={buttonEnabled ? 'primary' : 'gray'}
            disabled={buttonEnabled ? false : true}
        />
    </div>
}

export default StartProcess